import Axios from 'axios'
class CNS {
    constructor() {
        this.$modals = {}
        this.$fns = {}
        this.$events = {}

        this.$fns.getChildrenHeight = this.getChildrenHeight
        this.$fns.isSameOrChild = this.isSameOrChild
        this.showLogs = true
    }

    $ = function (selector) {
        return document.querySelector(selector)
    }

    $$ = function (selector) {
        return document.querySelectorAll(selector)
    }

    isAndroid = function () {
        return navigator.userAgent.toLowerCase().indexOf('android') > -1
    }

    isIOS = function () {
        return (
            [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
        )
    }

    checkVersion = function () {
        const agent = window.navigator.userAgent
        const start = agent.indexOf('OS ')
        if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
            return window.Number(agent.substr(start + 3, 3).replace('_', '.'))
        }
        return 0
    }

    shortenStr(str, maxLength = 20) {
        const length = str.length
            
        if (length <= maxLength) {
            return str
        }

        const extPos = str.lastIndexOf('.')
        const ext = str.slice(extPos + 1)
        const first = str.slice(maxLength - ext.length - 3)
        return first + '...' + ext
    }

    removeFileFromFileList(removeIndex, input) {
        const dt = new DataTransfer()
        const { files } = input
        
        for (let i = 0; i < files.length; i++) {
          if (removeIndex !== i) {
              dt.items.add(files[i]) 
          }
        }
        
        input.files = dt.files 
    }

    isSameOrChild(parent, el) {
        return parent === el || parent.contains(el)
    }

    getChildrenHeight = function(container) {
        const children = container.children;
        let totalHeight = 0;

        for (let i = 0; i < children.length; ++i) {
            totalHeight += parseInt(children[i].getBoundingClientRect().height, 10)
        }

        return totalHeight
    }

    log = (...msg) => {
        if (this.showLogs) {
            console.log(...msg)
        }
    }

    warn = (...msg) => {
        if (this.showLogs) {
            console.warn(...msg)
        }
    }

    getAllParentsWithClass(el, parentClass) {
        const parents = []

        for (let elem = el; !!elem && elem !== document; elem = elem.parentNode ) {

            if (!!elem && elem.classList.contains(parentClass)) {
                parents.push(elem);
            }
        }

        return parents
    }

    async getTranslation(key) {
        const locale = document.querySelector('html').lang
        let translationResponse = await Axios.get(`/lang/${locale}.json`)

        if (!translationResponse?.data?.success) {
            translationResponse = await Axios.get(`/lang/en.json`)
        }
        
        return translationResponse.data[key]
    }
}

window.CNS = new CNS()



// const tabEvent = new Event('tab-event')

